export default __webpack_public_path__ + "static/media/element_30.b5853f34.webp";